// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"43e1530c","962":"6d1637e2"}[chunkId] + ".js";
};